import { render, staticRenderFns } from "./MyInterviewsSection.vue?vue&type=template&id=3d275e60&scoped=true&"
import script from "./MyInterviewsSection.vue?vue&type=script&lang=js&"
export * from "./MyInterviewsSection.vue?vue&type=script&lang=js&"
import style0 from "./MyInterviewsSection.vue?vue&type=style&index=0&id=3d275e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d275e60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
